module.exports = __webpack_public_path__ + "static/media/443697980_433933449394685_6242461942572964849_n.9d998981.jpg";